module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 539
// module chunks = 0